module.exports = __webpack_public_path__ + "img/icon-arrow-right.2ebe74b2.svg";